module.exports = __webpack_public_path__ + "img/rsurvey.e9979605.svg";